import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import DaysToDeliverGrid from '../../../features/distributor/days-to-deliver-grid/components/DaysToDeliverGrid';

export default function DaysToDeliveryPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Days to Delivery')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<DaysToDeliverGrid />
			</div>
		</React.Fragment>
	)
} 
